import { render, staticRenderFns } from "./QuotazioneRCAForm.vue?vue&type=template&id=6c73dea4&scoped=true"
import script from "./QuotazioneRCAForm.vue?vue&type=script&lang=js"
export * from "./QuotazioneRCAForm.vue?vue&type=script&lang=js"
import style0 from "./QuotazioneRCAForm.vue?vue&type=style&index=0&id=6c73dea4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c73dea4",
  null
  
)

export default component.exports